import { render, staticRenderFns } from "./AssinaturaEletronica.vue?vue&type=template&id=891e1a5a&scoped=true&"
import script from "./AssinaturaEletronica.vue?vue&type=script&lang=js&"
export * from "./AssinaturaEletronica.vue?vue&type=script&lang=js&"
import style0 from "./AssinaturaEletronica.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AssinaturaEletronica.vue?vue&type=style&index=1&id=891e1a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891e1a5a",
  null
  
)

export default component.exports